export const SET_CART_VISIBLE_TABLE_COUNT = 'SET_CART_TABLE_VISIBILIT_COUNT';
